/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_Access_DescriptionInputs */

const en_no_access_description = /** @type {(inputs: No_Access_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your account isn't set up with any access yet. Contact an administrator to be granted a role.`)
};

const pt_br2_no_access_description = /** @type {(inputs: No_Access_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sua conta ainda não tem nenhum acesso configurado. Entre em contato com um administrador para receber uma função.`)
};

/**
* | output |
* | --- |
* | "Your account isn't set up with any access yet. Contact an administrator to be granted a role." |
*
* @param {No_Access_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const no_access_description = /** @type {((inputs?: No_Access_DescriptionInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_Access_DescriptionInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_no_access_description(inputs)
	return pt_br2_no_access_description(inputs)
});